import request from '@/shared/api/request';

/**
 *
 * Set new password.
 *
 * @param {string} token - A token that was provided in the email link
 * @param {object} data.newPassword - A a new password
 *
 * @returns {Promise}
 */
export const setPassword = (
  token: string,
  data: {
    new_password: string;
  },
): Promise<unknown> =>
  request({
    url: `/account/password_reset/${token}`,
    method: 'POST',
    data,
  });
